import { listsWithTasksOptions } from "@dashboard/api/queryApi";
import type { ListsWithTasksQuery } from "@dashboard/api/task";
import { useQuery } from "@tanstack/react-query";

export function useListsWithTasks(query: ListsWithTasksQuery) {
    return useQuery(listsWithTasksOptions(query));
}
